// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/background.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General styles */
body,
html {
  margin: 0;
  padding: 0;
}

/* Hero section styles */
.hero {
  font-family: "Fivo Sans Bold", sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  height: 100vh;
  background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0.9),
      rgba(37, 82, 149, 0.6)
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: cover;
  position: relative;
  background-position: center;
}

.hero-content {
  max-width: 50%;
  padding-left: 10em;
  justify-content: center;
}

.hero-content h1 {
  font-size: 3em;
  margin-bottom: 20px;
  font-family: "Fivo Sans Bold", sans-serif;
  text-align: left;
  color: #001a2d;
}

.hero-content p {
  font-size: 1.5em;
  margin-bottom: 30px;
  text-align: left;
  font-family: "Fivo Sans Light", sans-serif;
  color: #000;
}

.hero-image {
  position: relative;
  z-index: 2;
  width: 500px;
  height: 500px;
}

.cta-buttons {
  display: flex;
  gap: 20px;
}

.primary-btn,
.secondary-btn {
  width: 10em;
  padding: 15px 15px;
  font-size: 0.8em;
  justify-content: center;
  text-align: center;
  border-radius: 25px;
  cursor: pointer;
  transition: background-color 0.8s;
  font-weight: 600;
}

.primary-btn {
  background-color: #b51f25;
  color: white;
  text-transform: uppercase;
  border: 1px solid #b51f25;
  font-family: "Fivo Sans Medium", sans-serif;
}

.primary-btn:hover {
  background-color: #d23038;
  transition-duration: 0.4s;
}

.secondary-btn {
  background-color: transparent;
  color: #b51f25;
  border: 4px solid #b51f25;
  text-transform: uppercase;
}

.secondary-btn:hover {
  color: white;
  background-color: #d23038;
  border: 4px solid #d23038;
}
.primary-btn,
.secondary-btn {
  text-decoration: none;
}
.hero-image img {
  margin-top: 7em;
  max-width: 100%;
  height: auto;
}

/* Media Queries for responsiveness */
/* @media (min-width: 970px) {
  .hero {
    flex-direction: row;
    justify-content: flex-start;
  }

  .hero-content {
    max-width: 60%;
    justify-content: flex-start;
    text-align: start;
  }

  .hero-image {
    width: 400px;
    height: 400px;
    bottom: 20px;
    right: 20px;
    margin-top: 0;
  }
} */

@media (max-width: 971px) and (min-width: 768px) {
  .hero {
    flex-direction: column;
  }

  .hero-content {
    max-width: 80%;
    text-align: center;
    padding-left: 0;
  }
  .hero-image {
    width: 400px;
    height: 400px;
    position: relative;
  }
}

@media (max-width: 767px) {
  .hero {
    flex-direction: column;
  }

  .hero-content {
    max-width: 90%;
    text-align: center;
    padding-left: 1em;
  }
  .hero-content h1 {
    font-size: 2em;
  }

  .hero-content p {
    font-size: 1em;
  }

  .hero-image {
    width: 300px;
    height: 300px;
    padding-right: 0;
    position: relative;
    margin-top: 20px;
  }

  .primary-btn,
  .secondary-btn {
    width: 12em;
    padding: 12px;
    font-size: 0.8em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,yCAAyC;EACzC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb;;;;;mEAK+D;EAC/D,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA,qCAAqC;AACrC;;;;;;;;;;;;;;;;;;;GAmBG;;AAEH;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;AACF","sourcesContent":["/* General styles */\nbody,\nhtml {\n  margin: 0;\n  padding: 0;\n}\n\n/* Hero section styles */\n.hero {\n  font-family: \"Fivo Sans Bold\", sans-serif;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  height: 100vh;\n  background: linear-gradient(\n      to right,\n      rgba(255, 255, 255, 0.9),\n      rgba(37, 82, 149, 0.6)\n    ),\n    url(../assets/images/background.webp) no-repeat center center;\n  background-size: cover;\n  position: relative;\n  background-position: center;\n}\n\n.hero-content {\n  max-width: 50%;\n  padding-left: 10em;\n  justify-content: center;\n}\n\n.hero-content h1 {\n  font-size: 3em;\n  margin-bottom: 20px;\n  font-family: \"Fivo Sans Bold\", sans-serif;\n  text-align: left;\n  color: #001a2d;\n}\n\n.hero-content p {\n  font-size: 1.5em;\n  margin-bottom: 30px;\n  text-align: left;\n  font-family: \"Fivo Sans Light\", sans-serif;\n  color: #000;\n}\n\n.hero-image {\n  position: relative;\n  z-index: 2;\n  width: 500px;\n  height: 500px;\n}\n\n.cta-buttons {\n  display: flex;\n  gap: 20px;\n}\n\n.primary-btn,\n.secondary-btn {\n  width: 10em;\n  padding: 15px 15px;\n  font-size: 0.8em;\n  justify-content: center;\n  text-align: center;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: background-color 0.8s;\n  font-weight: 600;\n}\n\n.primary-btn {\n  background-color: #b51f25;\n  color: white;\n  text-transform: uppercase;\n  border: 1px solid #b51f25;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n}\n\n.primary-btn:hover {\n  background-color: #d23038;\n  transition-duration: 0.4s;\n}\n\n.secondary-btn {\n  background-color: transparent;\n  color: #b51f25;\n  border: 4px solid #b51f25;\n  text-transform: uppercase;\n}\n\n.secondary-btn:hover {\n  color: white;\n  background-color: #d23038;\n  border: 4px solid #d23038;\n}\n.primary-btn,\n.secondary-btn {\n  text-decoration: none;\n}\n.hero-image img {\n  margin-top: 7em;\n  max-width: 100%;\n  height: auto;\n}\n\n/* Media Queries for responsiveness */\n/* @media (min-width: 970px) {\n  .hero {\n    flex-direction: row;\n    justify-content: flex-start;\n  }\n\n  .hero-content {\n    max-width: 60%;\n    justify-content: flex-start;\n    text-align: start;\n  }\n\n  .hero-image {\n    width: 400px;\n    height: 400px;\n    bottom: 20px;\n    right: 20px;\n    margin-top: 0;\n  }\n} */\n\n@media (max-width: 971px) and (min-width: 768px) {\n  .hero {\n    flex-direction: column;\n  }\n\n  .hero-content {\n    max-width: 80%;\n    text-align: center;\n    padding-left: 0;\n  }\n  .hero-image {\n    width: 400px;\n    height: 400px;\n    position: relative;\n  }\n}\n\n@media (max-width: 767px) {\n  .hero {\n    flex-direction: column;\n  }\n\n  .hero-content {\n    max-width: 90%;\n    text-align: center;\n    padding-left: 1em;\n  }\n  .hero-content h1 {\n    font-size: 2em;\n  }\n\n  .hero-content p {\n    font-size: 1em;\n  }\n\n  .hero-image {\n    width: 300px;\n    height: 300px;\n    padding-right: 0;\n    position: relative;\n    margin-top: 20px;\n  }\n\n  .primary-btn,\n  .secondary-btn {\n    width: 12em;\n    padding: 12px;\n    font-size: 0.8em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
